// @ts-nocheck
import * as React from "react";

const AlertKishigo: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192.1 192.1">
            <polygon fill="currentColor" points="95,14.3 5,175.6 184,175.6" />
            <g>
                <path
                    fill="primary"
                    d="M108.2,144.4c0,7.1-4.7,12.3-12,12.3h-0.3c-7.1,0-11.9-5.3-11.9-12.3c0-7.3,5-12.3,12.2-12.3
                    C103.3,132.1,108.1,137.1,108.2,144.4z M88.4,125.3h15.4l3-61.3H85.5L88.4,125.3z M190.4,177c-2.2,3.7-6.2,5.9-10.5,5.9H12.3
                    c-4.4,0-8.5-2.4-10.7-6.2c-2.2-3.8-2.1-8.5,0.1-12.3L85.8,15.2c2.2-3.7,6.2-6,10.5-6h0.3c4.4,0.1,8.4,2.6,10.5,6.5L190.7,165
                    C192.7,168.8,192.6,173.3,190.4,177z M179.9,170.6L96.4,21.5L12.3,170.6H179.9z"
                />
            </g>
        </svg>
    );
};

export default React.memo(AlertKishigo);
